import { Serializable } from '../../../core/models/serializable';
import { CvBoxAccessTokenStatus } from './cv-box-access-token-status.enum';
import { StoreItemModel } from './store-item-model';

export class CvBoxAccessTokenModel
  implements Serializable<CvBoxAccessTokenModel>
{
  public cvBoxAccessTokenId: number;
  public statusId: CvBoxAccessTokenStatus;
  public createDate: Date;
  public processDate: Date;
  public terminateDate: Date;

  public cvSendExpireDate: Date;
  public cvViewExpireDate: Date;

  public applications: number;

  public customerId: number;
  public customerName: string;

  public storeItem: StoreItemModel;
  public storeItemId: number;

  public portfolioId: number;
  public portfolioName: string;
  public portfolioAccountManagerName: string;

  fromObject(object: any): CvBoxAccessTokenModel {
    Object.assign(this, object);

    if (object.storeItem != null) {
      const s = new StoreItemModel();
      this.storeItem = s.fromObject(object.storeItem);
    }

    return this;
  }
  toObject() {
    throw new Error('Method not implemented.');
  }
}
